//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('dataMiningList', {
//        templateUrl: 'views/components/views/dataMiningList/dataMiningList.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['dataMiningListService', function (dataMiningListService) {
//            const vm = this;
            
//            vm.model = {
//                itemsListDataMinings: []
//            };
            
//            async function loadDataMinings() {
//                vm.model.itemsListDataMinings = await dataMiningListService.listDataMinings();
//            }
            
//            vm.$onInit = async function () {
//                loadDataMinings();
//            }
//        }]
//    });
//})();
